import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/fetchPatch";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
// Build timestamp: 1770620059
